module.exports = __webpack_public_path__ + "media/images/countryrect/eh-02768ce245850b43625694a50780ee93.svg";